import prettier from 'prettier/standalone';
import parserBabel from 'prettier/plugins/babel';
import parserHtml from 'prettier/plugins/html';
import parserPostCss from 'prettier/plugins/postcss';
import parserJS from 'prettier/plugins/estree';
import { editor } from 'monaco-editor';

export const documentFormatProviderPrettier = {
  async provideDocumentFormattingEdits(
    model: editor.ITextModel,
    options: any,
    token: any,
  ) {
    try {
      let result = await prettier.format(model.getValue(), {
        filepath: model.uri.fsPath,
        plugins: [parserBabel, parserHtml, parserPostCss, parserJS],
        tabWidth: 2,
      });

      if (model.uri.fsPath.endsWith('.css')) {
        result = uppercaseHexColors(result);
      }

      if (model.uri.fsPath.endsWith('.html')) {
        result = replaceDoctype(result);
      }

      return [
        {
          text: result,
          range: model.getFullModelRange(),
        },
      ];
    } catch (error) {
      return [];
    }
  },
};

/**
 * Helper function which makes sure the DOCTYPE
 * tag in HTML files conforms to the curriculum
 * team standard.
 *
 * @param text editor content
 * @returns cleaned up editor content
 */
function replaceDoctype(text: string) {
  return text.replace(/<!DOCTYPE html/i, '<!doctype html');
}

/**
 * Helper function which turns lowercase
 * Hex color codes into uppercase to be conform
 * to the curriculum team standard.
 *
 * @param text css file content
 * @returns formatted css file content
 */
function uppercaseHexColors(text: string) {
  return text.replace(/#([a-f0-9]{3}){1,2}\b/gi, (hex) => hex.toUpperCase());
}
